/*
 * @Description: 日期处理
 */

// ---------------------------------------------------------------------------

/**
 * 比较日期
 * @param {*} dateString1 日期1
 * @param {*} dateString2 日期2
 */
function diffDate(dateString1, dateString2) {
	// 将日期字符串转换为时间戳
	const timestamp1 = new Date(dateString1).getTime(),
		timestamp2 = new Date(dateString2).getTime();
	return timestamp1 >= timestamp2;
}

// ---------------------------------------------------------------------------

/**
 * 获取当前日期
 */
function getTodayDate() {
	// 创建一个新的Date对象，表示当前日期和时间
	const currentDate = new Date();

	// 获取当前日期
	let day = currentDate.getDate();
	day = day < 10 ? '0' + day : day;

	// 获取当前月份（注意，月份是从0开始计数的，所以需要加1）
	let month = currentDate.getMonth() + 1;
	month = month < 10 ? '0' + month : month;

	// 获取当前年份
	const year = currentDate.getFullYear();

	// 将日期、月份和年份拼接成字符串
	return `${year}-${month}-${day}`;
}

// ---------------------------------------------------------------------------

export default {
	value: {},
	method: {
		diffDate,
		getTodayDate,
	}
};